_ = require 'lodash'

class LightboxSizeControl extends window.jui.FormSizeInput

  constructor: (options) ->
    super
    # over-ride the component "defaults"
    @options = _.merge @options, {
      label      : 'Lightbox Size'
      minWidth   : 100
      minHeight  : 100
      maxWidth   : 2000
      maxHeight  : 2000
      classNames : ['select']
    }, options

  setValue: ->
    super
    page = window.editor.page
    if page.isMobileBreakpoint()
      # On mobile, disable the width control and force its value to 320
      @width.disable()
      @width.value = page.getBreakpointByName('mobile').maxPageWidth
      @height.enable()
    else
      @width.enable()
      @height.enable()


module.exports = LightboxSizeControl



// WEBPACK FOOTER //
// ./src/ui/lightbox-size-control.coffee